// extracted by mini-css-extract-plugin
export default {"wrapper":"Dashboard_view_wrapper__qrxD0","heading":"Dashboard_view_heading__B7p2a"};